import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from './locales/en.json';  // Your English translations
import heTranslation from './locales/he.json';  // Your Hebrew translations

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      he: { translation: heTranslation }
    },
    lng: "en",  // Default language
    fallbackLng: "he",  // Fallback language
    interpolation: {
      escapeValue: false // React already safes from xss
    }
  });


export default i18n;
